import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber, loadLookupFromDataSource } from '../../../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "cda7ea31-387b-46ba-a61e-8e3d43f2a6b9";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const initialFormFields = {
        RECORD: '',
        ITEMCODE: '',
        LOTCODE: '',
        STATUS: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].ROWID;
        }
        else 
        {
            rowId.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/wm/codes/edit-lot?id=" + rowId.current;
    history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const { IDTYPE, ...filteredFormFields } = formFields;
        const filters = FillFilters(filteredFormFields);
        datasource.filter(filters);
        setResultData(datasource);
    }
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    }
    useEffect(() => {
        if (formFields.RECORD === '' && formFields.ITEMCODE === '' && formFields.LOTCODE === '' && formFields.STATUS === '')
        {
            setResultData(loadDatasource);
        }
    }, [formFields]);

    const handleFormLoad = useCallback(() => {
            loadLookupFromStaticData(formRefs, "STATUS", [{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }]);
        }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'text');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    
    const handleFieldChange = useCallback((name, value) => {
        
    }, []);


    const loadDatasource = () => {
        let store = createStore({
            key: 'ROWID',
            loadParams: formFields,
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Lot.GetLotsListingData}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2
                                                }}
                                            >
                                                Enter Your Query For Lot Data Entry
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='bf2b0202-6fa8-49b0-91a9-639e9b037b24'
                                    layoutName='WMLotDataEntrySearchForm'
                                    defaultFormSchema={SearchLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                    noSpacingBeforeFirstRow={true}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={searchPanelStatus ? "GridHeightAccordianOpen-single-row" : "GridHeightAccordianClose"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column visible={false} dataType="string" caption='Record #' dataField='RECORD' />
                            <Column dataType="string" caption='Item' dataField='ITEMCODE'/>
                            <Column dataType="string" caption='Lot' dataField='LOTCODE' />
                            <Column dataType="string" caption='Description - 1' dataField='DESCRIPTION_1' />
                            <Column dataType="string" caption='Description - 2' dataField='DESCRIPTION_2' />
                            <Column dataType="string" caption='Status' dataField='STATUS' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" caption='Introduced Dt' dataField='DATEINTRODUCED' />
                            <Column dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" caption='Available Dt' dataField='DATEAVAILABLE' />
                            <Column dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" caption='Expiration Dt' dataField='DATEEXPIRATION' />
                            <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Net Available' dataField='NETAVAILABLE' />
                            <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Available' dataField='AVAILABLE' />
                            <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Unavailable' dataField='OUT_UNAVAILABLE' />
                            <Column dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='On Hand' dataField='ON_HAND' />
                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to="/wm/codes/add-lot">
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                 <GridToolbarItem location="after">
                                 <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);